{
    "BILLED": "Billed",
    "CANCELLED": "Cancelled",
    "COMPLETED": "Completed",
    "LOST": "Lost",
    "OPEN": "Open",
    "OPEN_IN_PICKING": "Open in Picking",
    "OTHER": "Other",
    "PARTIALLY_BILLED": "Partially Billed",
    "PARTIALLY_PICKED": "Partially Picked",
    "PARTIALLY_RECEIVED": "Partially Received",
    "PARTIALLY_SHIPPED": "Partially Shipped",
    "PENDING": "Pending",
    "PICKED": "Picked",
    "PROCESSED_INTERNALLY": "Processed Internally",
    "RECEIVED": "Received",
    "RELEASED_FOR_BILLING": "Released for Billing",
    "RELEASED_FOR_DELIVERY": "Released for Delivery",
    "RETURNED": "Returned",
    "REVISED": "Revised",
    "SHIPPED": "Shipped",
    "UNKNOWN": "Unknown",
    "WON": "Won"
}
